import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_89: FaireProductEntity = {
  token: "starter_collection_89",
  type: "product",
  name: "The Salt Sphere",
  brandName: "Material",
  imageUrl:
    "https://cdn.faire.com/fastly/776c155c67756e497f2b58e4fd69c3ecc2277b09dac80a6e5b1f1ed2ddd47854.png?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=1440&width=1440",
  priceDollars: 28,
  msrpDollars: 56,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
